require(134);
module.exports = require(53).Object.getPrototypeOf;
